<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:02:41
-->
<template>
  <div class="bidFail">
    <div class="list">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <businessItem
            @action="changeStatus"
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
          >
          </businessItem>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup class="bidPopUp" v-model="show" closeable round>
      <p class="popUpTitle">预装时间：</p>
      <div class="pickUnit" @click="datastu = true">
        <p>{{ currentUnit.loadDate }}</p>
      </div>
      <p class="popUpTitle">货物种类：</p>
      <div class="pickUnit" @click="goods = true">
        <p>{{ currentUnit.goodsType }}</p>
      </div>
      <p class="popUpTitle">承运单位：</p>
      <div class="pickUnit" @click="showShipper = true">
        <p>{{ currentUnit.shipperName }}</p>
      </div>

      <p class="popUpTitle">中标单位：</p>
      <div class="pickUnit" @click="showUnit = true">
        <p>{{ currentUnit.comp }}</p>
      </div>
      <p class="popUpTitle">运输单位：</p>
      <div class="pickUnit" @click="showUnitcar = true">
        <p>{{ currentUnit.cargoOwner }}</p>
      </div>
      <van-button class="unitButton" type="primary" @click="submit"
        >更新</van-button
      >
    </van-popup>
    <van-popup
      v-model="showShipper"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="选择承运单位"
        :columns="unitList"
        @confirm="onConfirmShipper"
        value-key="comp"
        @cancel="onCancelShipper"
        :default-index="defaultShipperIndex"
      />
    </van-popup>
    <van-popup v-model="showUnit" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="选择中标单位"
        :columns="unitList"
        @confirm="onConfirm"
        value-key="comp"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup
      v-model="showUnitcar"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="选择运输单位"
        :columns="unitList"
        @confirm="onConfirmCarg"
        value-key="comp"
        @cancel="onCancelcar"
      />
    </van-popup>
    <van-popup v-model="goods" position="bottom" :style="{ height: '30%' }">
      <van-picker
        show-toolbar
        title="物种种类"
        :columns="typegoodLi"
        @confirm="ongoods"
        value-key="dictLabel"
        @cancel="cangoods"
      />
    </van-popup>
    <van-popup v-model="datastu" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="ondatastu"
        @cancel="centastu"
      />
    </van-popup>
    <van-notify v-model="showNotice">
      <span>请选择中标单位</span>
    </van-notify>
  </div>
</template>

<script>
import {
  palletsList,
  getBindUnitList,
  updateBidUnit,
  gettypegood,
} from "@/utils/network/interface";
import businessItem from "./item";
export default {
  name: "bidFail",
  components: {
    businessItem,
  },
  props: {
    keyWord: String,
  },
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(2050, 10, 1),
      datastu: false,
      goods: false,
      tableList: [],
      show: false,
      currentRow: {},
      unitList: [],
      typegoodLi: [],
      currentUnit: {
        cargoOwnerId: null,
        cargoOwner: "",
        comp: "",
        goodsType: "",
        id: null,
        loadDate: "",
        shipperId: 6,
        shipperName: null,
        bidderId: "",
      },
      columns: [{ text: "杭州" }, { text: "宁波" }, { text: "温州" }],
      showShipper: false,
      showUnit: false,
      showUnitcar: false,
      showNotice: false,
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,

      defaultShipperIndex: 0,
    };
  },
  watch: {
    keyWord(newVal, oldVal) {
      this.pageInfo.pageNum = 1;
      this.tableList = [];
      this.onLoad();
    },
  },
  created() {
    this.getUnitList();
    this.gettypegoodList();
  },
  mounted() {},
  methods: {
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.tableList = [];
          this.refreshing = false;
        }
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { state: 1, pageSize, pageNum, bizName: this.keyWord };
        palletsList(obj)
          .then((res) => {
            if (res.code === 200) {
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.loading = false;
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 1000);
    },
    getData() {
      let obj = { state: 1, pageSize: 10, pageNum: 1, bizName: this.keyWord };
      palletsList(obj)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;
          if (res.code == 200) {
            this.tableList = res.rows;
            this.pageInfo.pageNum++;
            this.pageInfo.total = res.total;
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
    },
    getUnitList() {
      getBindUnitList().then((res) => {
        this.unitList = res.data;
        console.log(res, "res");
        //承运单位默认值
        if (this.unitList) {
          this.unitList.filter((value, index) => {
            if (value.id === 6) {
              this.defaultShipperIndex = index;
              this.currentUnit.shipperId = value.id;
              this.currentUnit.shipperName = value.comp;
            }
          });
        }
      });
    },
    gettypegoodList() {
      gettypegood().then((res) => {
        this.typegoodLi = res.data;
      });
    },
    changeStatus(data) {
      this.currentRow = data;
      this.currentUnit.loadDate = data.loadDate;
      this.currentUnit.goodsType = data.goodsType;
      //
      this.currentUnit.cargoOwner = data.cargoOwner;
      this.currentUnit.cargoOwnerId = data.cargoOwnerId;
      this.currentUnit.id = data.bidderId;
      this.currentUnit.comp = data.bidderName;
      //
      // console.log(data)
      this.show = true;
    },
    onConfirm(value, index) {
      // console.log(value,index)
      this.currentUnit.id = this.unitList[index].id;
      this.currentUnit.comp = this.unitList[index].comp;
      // this.currentUnit.cargoOwnerId = this.unitList[index].cargoOwnerId
      console.log(this.unitList);
      this.showUnit = false;
    },
    onConfirmCarg(value, index) {
      // this.currentUnit.id = this.unitList[index].id;
      this.currentUnit.cargoOwner = this.unitList[index].comp;
      this.currentUnit.cargoOwnerId = this.unitList[index].id;
      console.log(this.unitList);
      this.showUnitcar = false;
    },
    onCancelcar() {
      this.showUnitcar = false;
    },
    onCancel() {
      this.showUnit = false;
    },

    //承运单位选择
    onConfirmShipper(value, index) {
      this.currentUnit.shipperId = value.id;
      this.currentUnit.shipperName = value.comp;
      this.showShipper = false;
    },
    onCancelShipper() {
      this.showShipper = false;
    },

    ondatastu(va) {
      let data_v = new Date(va);
      let date_value =
        data_v.getFullYear() +
        "-" +
        (data_v.getMonth() + 1) +
        "-" +
        data_v.getDate();
      this.currentUnit.loadDate = date_value;

      this.datastu = false;
    },
    centastu() {
      this.datastu = false;
    },
    // 物种种类
    ongoods(va) {
      console.log(va.dictLabel);
      this.currentUnit.goodsType = va.dictLabel;
      this.goods = false;
    },
    cangoods() {
      this.goods = false;
    },
    submit() {
      if (!this.currentUnit.id) {
        this.showNotice = true;
        setTimeout(() => {
          this.showNotice = false;
        }, 2000);
      } else {
        let params = {
          cargoOwnerId: this.currentUnit.cargoOwnerId,
          bidderId: this.currentUnit.id,
          comp: this.currentUnit.comp,
          id: this.currentRow.id,
          loadDate: this.currentUnit.loadDate,
          goodsType: this.currentUnit.goodsType,
          shipperId: this.currentUnit.shipperId,
          shipperName: this.currentUnit.shipperName,
        };
        updateBidUnit(params).then((res) => {
          // console.log(res)
          if (res.code !== 200) {
            this.$toast({
              type: "fail",
              message: res.msg,
            });
          } else {
            this.$toast({
              type: "success",
              message: "修改成功",
            });
            this.currentRow = {};
            this.currentUnit = {};
            this.show = false;
            this.getData();
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bidFail {
  .bidPopUp {
    padding: 20px;
    width: 80%;
    height: 420px;

    .popUpTitle {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 600;
      text-align: left;
      color: #333333;
      line-height: 18px;
      margin-bottom: 10px;
    }

    .pickUnit {
      height: 30px;
      background: #eeeeee;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      line-height: 30px;
      background: url("../../../../assets/accountant/selectDown.png")
        calc(100% - 10px) center no-repeat;
      background-size: 12px 10px;
      margin-bottom: 10px;
      padding-left: 10px;
      padding-right: 25px;
      font-size: 14px;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .unitButton {
      width: 142px;
      height: 28px;
      background: #44b1f9;
      border-radius: 5px;
      display: block;
      margin: 0 auto;
      border: 1px solid #44b1f9;
    }
  }
}
</style>